module.exports = __webpack_public_path__ + "static/media/hostel.bf231741.svg";